import { useState, useRef, useEffect } from 'react';
import './AppHeader.css';

function AppHeaderMenu({ user, onSignOut }) {
    const [open, setOpen] = useState(false);
    const wrapRef = useRef(null);

    useEffect(() => {
        if (!open) return;
        const onDocDown = (e) => {
            if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
        };
        const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
        document.addEventListener('mousedown', onDocDown);
        document.addEventListener('touchstart', onDocDown);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onDocDown);
            document.removeEventListener('touchstart', onDocDown);
            document.removeEventListener('keydown', onKey);
        };
    }, [open]);

    if (!user) return null;

    return (
        <div className="appHeaderMenu" ref={wrapRef}>
            <button
                className={`appHeaderMenuBtn${open ? ' appHeaderMenuBtn--open' : ''}`}
                onClick={() => setOpen(o => !o)}
                aria-label="More menu"
                aria-expanded={open}
            >
                <span aria-hidden="true">⋯</span>
            </button>
            {open && (
                <div className="appHeaderMenuDropdown" role="menu">
                    <button
                        className="appHeaderMenuItem appHeaderMenuItem--danger"
                        role="menuitem"
                        onClick={() => { setOpen(false); onSignOut(); }}
                    >
                        Sign out
                    </button>
                </div>
            )}
        </div>
    );
}

const NAV = [
    { key: 'video', label: 'Video' },
    { key: 'photo', label: 'Photo' },
    { key: 'games', label: 'Games' },
];

function SubPill({ subStatus, credits, onAccount }) {
    if (subStatus === 'active') {
        return (
            <button className="appSubPill appSubPill--active" onClick={onAccount}>
                <span className="appSubPillCredits">{credits}</span>
                credits
            </button>
        );
    }
    if (subStatus === 'cancelled') {
        return (
            <button className="appSubPill appSubPill--cancelled" onClick={onAccount}>
                Cancelled
            </button>
        );
    }
    return (
        <button className="appSubPill appSubPill--upgrade" onClick={onAccount}>
            <span className="appSubPillStar" aria-hidden="true">★</span>
            Upgrade
        </button>
    );
}

export function AppHeader({ active, user, subStatus, authPending, onNavigate, onLogin, onAccount, onSignOut }) {
    return (
        <div className="appHeader">
            <div className="appHeaderLeft">
                <span
                    className="appLogo"
                    style={{ cursor: 'pointer' }}
                    onClick={() => onNavigate('video')}
                >
                    Make<span className="appLogoAccent">porn</span>
                </span>
                <nav className="appNav">
                    {NAV.map(item => (
                        <button
                            key={item.key}
                            className={`appNavBtn${active === item.key ? ' appNavBtn--active' : ''}`}
                            onClick={() => onNavigate(item.key)}
                        >
                            {item.label}
                        </button>
                    ))}
                </nav>
            </div>
            <div className="appHeaderRight">
                {user ? (
                    <>
                        <SubPill subStatus={subStatus} credits={user.credits ?? 0} onAccount={onAccount} />
                        <button
                            className="appSignOutBtn appSignOutBtn--desktopOnly"
                            onClick={onSignOut}
                        >
                            Sign out
                        </button>
                    </>
                ) : authPending ? (
                    <span
                        aria-hidden="true"
                        style={{ display: 'inline-block', width: 92, height: 30, borderRadius: 6, background: 'rgba(255,255,255,0.06)' }}
                    />
                ) : (
                    <button className="appLoginBtn" onClick={onLogin}>Log in</button>
                )}
                <AppHeaderMenu user={user} onSignOut={onSignOut} />
            </div>
        </div>
    );
}
